export default __webpack_public_path__ + "static/human-rights-banner-bf98b5c2b57bfe310c7e83c3c668bc91.png";